import { Observable } from 'rxjs';
import { SchedulePartialStoreState, SCHEDULE_STATE_KEY } from '../schedule.reducer';

export const getOriginResults = (state: SchedulePartialStoreState) =>
    state[SCHEDULE_STATE_KEY].planner.origins.all;

export const getDestinationResults = (state: SchedulePartialStoreState) =>
    state[SCHEDULE_STATE_KEY].planner.destinations.all;

export const getSelectedOrigin = (state: SchedulePartialStoreState) =>
    state[SCHEDULE_STATE_KEY].planner.selectedOrigin;

export const getSelectedDestination = (state: SchedulePartialStoreState) =>
    state[SCHEDULE_STATE_KEY].planner.selectedDestination;

export const getTrips = (state: SchedulePartialStoreState) =>
    state[SCHEDULE_STATE_KEY].planner.trips;

export const getTripsLoading = (state: SchedulePartialStoreState) =>
    state[SCHEDULE_STATE_KEY].planner.loading;

export const getSelectedTripId = (state: SchedulePartialStoreState) =>
    state[SCHEDULE_STATE_KEY].planner.selectedTripId;

export const getSelectedTrip = (state: SchedulePartialStoreState) => 
    state[SCHEDULE_STATE_KEY].planner.selectedTripId !== null &&
        state[SCHEDULE_STATE_KEY].planner.trips[state[SCHEDULE_STATE_KEY].planner.selectedTripId];

export const getSelectedDate = (state: SchedulePartialStoreState) =>
    state[SCHEDULE_STATE_KEY].planner.selectedDate;

export const getSelectedPriority = (state: SchedulePartialStoreState) =>
    state[SCHEDULE_STATE_KEY].planner.selectedPriority;

export const resetTrips = (state: SchedulePartialStoreState) =>
    state[SCHEDULE_STATE_KEY].planner.trips;
